module.exports = __webpack_public_path__ + "static/img/model-top-bg.22524aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/model-top-bg.png
// module id = Y5aF
// module chunks = 1